import { ThemeEvents } from '@theme/events'
import { ProductCard } from '@theme/product-card'
import { VariantPicker } from '@theme/variant-picker'

class SwatchesVariantPickerComponent extends VariantPicker {
  connectedCallback() {
    super.connectedCallback()

    this.parentProductCard = this.closest('product-card')

    this.addEventListener(
      ThemeEvents.variantUpdate,
      this.#handleCardVariantUrlUpdate
    )
  }

  #handleCardVariantUrlUpdate = () => {
    if (
      this.pendingVariantId &&
      this.parentProductCard instanceof ProductCard
    ) {
      const currentUrl = new URL(
        this.parentProductCard.refs.productCardLink.href
      )
      currentUrl.searchParams.set('variant', this.pendingVariantId)
      this.parentProductCard.refs.productCardLink.href = currentUrl.toString()
      this.pendingVariantId = null
    }
  }

  variantChanged(event) {
    if (!(event.target instanceof HTMLElement)) {
      return
    }

    const isSwatchInput =
      event.target instanceof HTMLInputElement &&
      event.target.name?.includes('-swatch')
    const clickedSwatch = event.target
    const availableCount = Number.parseInt(
      clickedSwatch.dataset.availableCount || '0',
      10
    )
    const firstAvailableVariantId =
      clickedSwatch.dataset.firstAvailableOrFirstVariantId

    if (isSwatchInput && availableCount > 0 && firstAvailableVariantId) {
      event.stopPropagation()

      this.updateSelectedOption(clickedSwatch)

      const productUrl = this.dataset.productUrl?.split('?')[0]

      if (!productUrl) {
        return
      }

      const url = new URL(productUrl, window.location.origin)
      url.searchParams.set('variant', firstAvailableVariantId)
      url.searchParams.set('section_id', 'product-card')

      const requestUrl = url.href

      this.pendingVariantId = firstAvailableVariantId

      this.fetchUpdatedSection(requestUrl)
      return
    }

    super.variantChanged(event)
  }
}

if (!customElements.get('swatches-variant-picker-component')) {
  customElements.define(
    'swatches-variant-picker-component',
    SwatchesVariantPickerComponent
  )
}
